function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { bool, func, node, object, oneOf, string } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import SovosDrawerHeader from '../sovos-drawer-header/SovosDrawerHeader';
import { findChildrenByType, filterOutChildrenByType } from '../internals/utils/reactHelpers';
const StyledDrawer = styled(Drawer)(_ref => {
  let {
    size = 'small',
    theme: {
      spacing
    }
  } = _ref;
  const drawerWidths = {
    small: spacing(48),
    large: spacing(68)
  };
  return {
    '& .sovosDrawer__container': {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      maxWidth: '100vw',
      width: drawerWidths[size]
    },
    '& .sovosDrawer__content': {
      padding: "".concat(spacing(2), " ").concat(spacing(3)),
      overflowY: 'auto',
      flex: '1 1 auto'
    }
  };
});
const transitionsTimeout = 300;
const paperProps = {
  component: 'aside',
  elevation: 16
};
const SovosDrawer = _ref2 => {
  let {
    children,
    className,
    onClose,
    open,
    size,
    style,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledDrawer, _extends({
    anchor: "right",
    className: clsx('sovosDrawer', className),
    open: open,
    onClose: onClose,
    PaperProps: paperProps,
    size: size,
    slotProps: {
      backdrop: {
        'data-testid': 'sovosModalBackdrop'
      }
    },
    style: style,
    transitionDuration: transitionsTimeout
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "sovosDrawer__container"
  }, findChildrenByType(children, SovosDrawerHeader), /*#__PURE__*/React.createElement("div", {
    className: "sovosDrawer__content",
    "data-testid": "drawerContent"
  }, filterOutChildrenByType(children, SovosDrawerHeader))));
};
SovosDrawer.propTypes = {
  /**
   * The content of the drawer
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Callback fired when the drawer is closed, i.e. when the user clicks off of it
   */
  onClose: func.isRequired,
  /**
   * The drawer's open state
   */
  open: bool.isRequired,
  /**
   * The drawer's width
   *
   * - `small`: 384px
   * - `large`: 544px
   */
  size: oneOf(['small', 'large']),
  /**
   * Inline styles applied to the root element
   */
  style: object
};
SovosDrawer.baseComponent = {
  name: 'Drawer',
  link: 'drawer/'
};
export default SovosDrawer;